// extracted by mini-css-extract-plugin
module.exports = {"inner":"EditorFooter_inner__3-3DN","errorLogs":"EditorFooter_errorLogs__1av9l"};